import React, { ReactElement } from 'react';
import { ConnectionLine } from '../Connections/ConnectionLine';
import { TEMP_CONNECTION_GUIDE_LINE } from '../../constants';

export const AddingLogicalConnectionGuideLine = (): ReactElement => {
  return <ConnectionLine connection={TEMP_CONNECTION_GUIDE_LINE} />;
};
